import React, { useCallback, useContext } from 'react'
import PropTypes from 'prop-types'
import { get, identity, set } from 'lodash'

import FilterBarContext from '../context'
import { findSectionElement } from '../utils'
import { Toggle as ToggleComponent } from '../../Toggle'

const Toggle = ({ onChange, hierarchy }) => {
  const { filters } = useContext(FilterBarContext)
  const toggled = get(filters, hierarchy)

  const onToggleChange = useCallback(
    (newToggled) => {
      onChange((filters, newSections) => {
        const clonedFilters = { ...filters }
        set(clonedFilters, hierarchy, newToggled)

        const clonedNewSections = [...newSections]
        const sectionElement = findSectionElement(clonedNewSections, hierarchy)

        sectionElement.elements[0].value = newToggled

        return { clonedFilters, clonedNewSections }
      }, hierarchy)
    },
    [onChange, hierarchy]
  )

  return (
    <ToggleComponent
      id={hierarchy.join('')}
      toggled={toggled}
      onToggle={onToggleChange}
    />
  )
}

Toggle.propTypes = {
  items: PropTypes.array,
  onChange: PropTypes.func,
  hierarchy: PropTypes.arrayOf(PropTypes.string)
}

Toggle.defaultProps = {
  items: [],
  onChange: identity,
  hierarchy: []
}

export default React.memo(Toggle)
